export default __webpack_public_path__ + "static/media/compatio.f2e6bfc2.png";